const phoneAnalytics = 'phone-analytics';

export const trackingIds = {
  callAnalyticsPDFExport: `${phoneAnalytics}-call-analytics-pdf-export`,
  callAnalyticsTab: `${phoneAnalytics}-call-analytics-tab`,
  callGroupsTab: `${phoneAnalytics}-call-group-analytics-tab`,
  callQueuesTab: `${phoneAnalytics}-call-group-queue-tab`,
  chartsView: `${phoneAnalytics}-charts-view-tab`,
  clearFilters: `${phoneAnalytics}-clear-filters`,
  deviceExtensionsCallsAnswered: `${phoneAnalytics}-device-extensions-calls-answered`,
  deviceExtensionsCallsPlaced: `${phoneAnalytics}-device-extensions-calls-placed`,
  deviceExtensionsFilter: `${phoneAnalytics}-device-extensions-filter`,
  downloadMain: `${phoneAnalytics}-download-main`,
  durationAnalyticsPDFExport: `${phoneAnalytics}-duration-analytics-pdf-export`,
  durationAnalyticsTab: `${phoneAnalytics}-duration-analytics-tab`,
  exportTableData: `${phoneAnalytics}-export-table-data`,
  exportTableDataCancel: `${phoneAnalytics}-export-table-data-cancel`,
  exportTableDataConfirm: `${phoneAnalytics}-export-table-data-confirm`,
  filtersOpen: `${phoneAnalytics}-filters-open`,
  locationsFilter: `${phoneAnalytics}-locations-filter`,
  helpVideo: `${phoneAnalytics}-help-video`,
  routingAnalyticsTab: `${phoneAnalytics}-routing-analytics-tab`,
  routingAnalyticsCharts: `${phoneAnalytics}-routing-analytics-phoneTreeCallVolumePanel`,
  tableView: `${phoneAnalytics}-table-view-tab`,
  timePeriodOnTrayFilter: `${phoneAnalytics}-time-period-on-tray-filter`,
  timeFilter: `${phoneAnalytics}-time-filter`,
} as const;
